<template>
  <section class="financial-bank-accounts-toolbar app-filter-toolbar">
    <div class="toolbar-main-row app-filter-toolbar-row">
      <div class="search-wrap app-filter-search-wrap">
        <i class="fa fa-search" aria-hidden="true"></i>
        <input
          :value="search"
          type="text"
          :placeholder="text.bankAccounts.searchPlaceholder"
          @input="emitSearch($event.target.value)"
        />
      </div>

      <div class="financial-bank-accounts-toolbar__right toolbar-right app-filter-toolbar-right">
        <div class="financial-view-toggle" role="group" :aria-label="text.bankAccounts.viewModeAriaLabel || 'Modo de visualización de cuentas'">
          <button
            type="button"
            class="financial-view-toggle__btn"
            :class="{ active: viewMode === 'cards' }"
            @click="$emit('view-mode-change', 'cards')"
            :title="text.bankAccounts.cardsViewTitle || 'Vista en cards'"
            :aria-label="text.bankAccounts.cardsViewAriaLabel || 'Vista en cards'"
          >
            <i class="fa fa-th-large" aria-hidden="true"></i>
          </button>

          <button
            type="button"
            class="financial-view-toggle__btn"
            :class="{ active: viewMode === 'table' }"
            @click="$emit('view-mode-change', 'table')"
            :title="text.bankAccounts.tableViewTitle || 'Vista en listado'"
            :aria-label="text.bankAccounts.tableViewAriaLabel || 'Vista en listado'"
          >
            <i class="fa fa-list" aria-hidden="true"></i>
          </button>
        </div>

        <StatusTabs
          :tabs="statusTabs"
          :active-tab="statusFilter"
          @select="$emit('status-change', $event)"
        />
      </div>
    </div>
  </section>
</template>

<script>
import StatusTabs from '@/components/common/StatusTabs.vue';

export default {
  name: 'FinancialBankAccountsToolbar',
  components: {
    StatusTabs,
  },
  props: {
    text: {
      type: Object,
      required: true,
    },
    search: {
      type: String,
      default: '',
    },
    viewMode: {
      type: String,
      default: 'cards',
    },
    statusFilter: {
      type: String,
      default: 'active',
    },
    statusTabs: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['search-change', 'view-mode-change', 'status-change'],
  methods: {
    emitSearch(value) {
      this.$emit('search-change', String(value || ''));
    },
  },
};
</script>

<style scoped>
.financial-bank-accounts-toolbar__right {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.financial-bank-accounts-toolbar :deep(.status-tabs) {
  margin-top: 0;
}

.financial-view-toggle {
  display: inline-flex;
  align-items: center;
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
}

.financial-view-toggle__btn {
  border: 0;
  border-right: 1px solid rgba(148, 163, 184, 0.25);
  background: transparent;
  min-height: 34px;
  min-width: 34px;
  padding: 0 8px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.financial-view-toggle__btn:last-child {
  border-right: 0;
}

.financial-view-toggle__btn.active {
  background: rgba(0, 112, 205, 0.1);
  color: #0070cd;
}

@media (max-width: 1200px) {
  .financial-bank-accounts-toolbar__right {
    width: 100%;
    justify-content: space-between;
  }
}

@media (max-width: 767px) {
  .financial-bank-accounts-toolbar__right {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .financial-view-toggle {
    width: 100%;
  }

  .financial-view-toggle__btn {
    flex: 1;
  }
}
</style>
